"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSCLimarkoMaritimeAgency = void 0;
exports.JSCLimarkoMaritimeAgency = {
    id: 'jscLimarkoMaritimeAgency',
    companyName: 'JSC Limarko Maritime Agency',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'jscLimarkoMaritimeAgency',
    },
    isInternal: false,
    isActive: true,
    countries: ['LT'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSlNDTGltYXJrb01hcml0aW1lQWdlbmN5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL0pTQ0xpbWFya29NYXJpdGltZUFnZW5jeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHdCQUF3QixHQUFVO0lBQzNDLEVBQUUsRUFBRSwwQkFBMEI7SUFDOUIsV0FBVyxFQUFFLDZCQUE2QjtJQUMxQyxjQUFjLEVBQUUsQ0FBQyxLQUFLLENBQUM7SUFDdkIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLDBCQUEwQjtLQUNwQztJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==